export default function getDebugAuthId() {
    const debugAuthId = process.env.REACT_APP_AUTH_ID;
    if (debugAuthId) {
        // eslint-disable-next-line no-console
        console.warn(`DEBUGGING WITH: ${debugAuthId}`);
    }
    return debugAuthId;
}
